import React from 'react'
import { useStyles } from './CourStyle'

//Material UI
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import MovieIcon from '@material-ui/icons/MovieTwoTone'
import IconButton from '@material-ui/core/IconButton'

export default function Cour(props) {
  const classes = useStyles()
  const { id, nom, date, videoLink } = props

  return (
    <div className={classes.root}>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead className={classes.head}>
            <TableRow>
              <TableCell>N°</TableCell>
              <TableCell>Activité</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Vidéo</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>{id}</TableCell>
              <TableCell>Cours de {nom}</TableCell>
              <TableCell>{date}</TableCell>
              <TableCell>
                <IconButton onClick={() => console.log({ videoLink })}>
                  <MovieIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  )
}
